import { motion } from "framer-motion";
import { Shield, MapPin, Users, Radio } from "lucide-react";

/**
 * Trust strip — sits directly under the hero.
 * Only defensible facts. Never invents numbers.
 */
export const TrustStrip = () => {
    const items = [
        { icon: MapPin, k: "Real, live inventory", v: "Every screen on our map is bookable — not a stock catalogue." },
        { icon: Shield, k: "Stripe-secured payments", v: "Card payment in AUD with GST included. Invoice + receipt on the spot." },
        { icon: Radio, k: "20-minute holds at checkout", v: "Your screens are yours while you finish paying — nobody else can grab them." },
        { icon: Users, k: "A real campaign director", v: "One person on your account from booking to go-live. Not a call-centre queue." },
    ];

    return (
        <section
            id="trust"
            data-testid="landing-trust-strip"
            className="relative py-20 lg:py-24 border-t border-white/5"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                    {items.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <motion.div
                                key={it.k}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.6, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
                                whileHover={{ y: -4 }}
                                className="group bg-white/[0.03] backdrop-blur border border-white/10 hover:border-[#FF5A00]/40 p-8 lg:p-10 transition-all duration-500"
                            >
                                <div className="inline-flex items-center justify-center w-11 h-11 border border-[#FF5A00]/30 bg-[#FF5A00]/5 mb-6 group-hover:bg-[#FF5A00]/15 transition-colors">
                                    <Icon className="text-[#FF5A00]" size={20} strokeWidth={1.5} />
                                </div>
                                <div className="font-display font-black text-lg text-white tracking-tight">
                                    {it.k}
                                </div>
                                <div className="mt-3 text-sm text-slate-400 leading-relaxed">
                                    {it.v}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
